import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { IStyled } from '../../styles/types';
import { theme } from '../../styles/theme';
import InformationalTooltip from '../InformationalTooltip';
import IconWrapper from '../Icon/IconWrapper';
import { SvgIcon } from '../Icon';
import { iconList } from '../Icon/iconList';
import { ITooltipOption } from '../KubitTooltip/globalTooltips';

interface IProps extends IStyled {
  children: ReactNode;
  tooltipOption?: ITooltipOption;
  /**
   * Custom icon
   * Must be a key from the iconList object
   */
  icon?: keyof typeof iconList;
}

const Container = styled.label`
  display: flex;
  column-gap: 4px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  align-items: center;
  color: ${theme.colors.secondary900};
`;

export default ({ children, className, tooltipOption, icon }: IProps) => (
  <Container className={className}>
    {icon && (
      <IconWrapper size={16}>
        <SvgIcon name={icon} customFill="currentColor" />
      </IconWrapper>
    )}
    {children}
    {tooltipOption && <InformationalTooltip tooltipOption={tooltipOption} />}
  </Container>
);
